import {InjectionToken} from '@angular/core';

/**
 * Third party ID (also called frontEndRef) hosting the web/mobile app.
 * Beware, this third party id may not be the actual third party id of the current connected user in case of a twinning relationship between two front operators.
 */
export const HOST_THIRD_PARTY_ID = new InjectionToken<string>('Third party ID (also called frontEndRef) hosting the web/mobile app. ' +
    'Beware, this third party id may not be the actual third party id of the current connected user in case of a twinning relationship between two front operators.');
